var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "chart-header"
  }, [_c("h2", [_vm._v("诈骗会话")]), _c("div", {
    staticClass: "wlc-f-c"
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "214px"
    },
    attrs: {
      type: "daterange",
      align: "right",
      "unlink-panels": "",
      "range-separator": "-",
      "start-placeholder": "start",
      "end-placeholder": "end",
      size: "small",
      clearable: false,
      "picker-options": _vm.pickerOptions,
      format: "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      change: _vm.init
    },
    model: {
      value: _vm.dateTime,
      callback: function callback($$v) {
        _vm.dateTime = $$v;
      },
      expression: "dateTime"
    }
  }), _c("el-dropdown", {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      command: _vm.command
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("grain")(_vm.communityGrain)) + " ")]), _c("el-dropdown-menu", {
    attrs: {
      slot: "dropdown"
    },
    slot: "dropdown"
  }, [_c("el-dropdown-item", {
    attrs: {
      command: "day"
    }
  }, [_vm._v("天")]), _c("el-dropdown-item", {
    attrs: {
      command: "week"
    }
  }, [_vm._v("周")]), _c("el-dropdown-item", {
    attrs: {
      command: "month"
    }
  }, [_vm._v("月")]), _c("el-dropdown-item", {
    attrs: {
      command: "quarter"
    }
  }, [_vm._v("季")]), _c("el-dropdown-item", {
    attrs: {
      command: "year"
    }
  }, [_vm._v("年")])], 1)], 1)], 1)]), _c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "chart-container",
    attrs: {
      id: "fraud-sessions"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };